import React, { useState } from "react";
import { Modal, TextField, Button, Box } from "@mui/material";
import { H5 } from "./Typography";
import { load } from "../constants/storage";

import { useAppDispatch } from "../store/hooks";
import toast from "react-hot-toast";
import { VerifyIFSC } from "models";
import { verifyIFSC } from "../redux/actions/KYCAction";

type FormValues = {
  accountNo: string;
  confirmAccountNo: string;
  fullname: string;
  ifscCode: string;
  bank_name: string;
};

type FormErrors = {
  accountNo?: string;
  confirmAccountNo?: string;
  fullname?: string;
  ifscCode?: string;
  bank_name?: string;
};

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: (value: any) => void;
};

function AddBankModel({ open, handleClose, handleSave }: MyModalProps) {
  const [formValues, setFormValues] = useState<FormValues>({
    accountNo: "",
    confirmAccountNo: "",
    fullname: "",
    ifscCode: "",
    bank_name: "",
  });
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const dispatch = useAppDispatch();
  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" }); // clear any previous errors for this field
  }
  const onhandleIFSCBlur = async () => {
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let token = load("token");

    const data: VerifyIFSC = {
      id: finalUser.id,
      mobile: finalUser.mobile,
      ifsc: formValues.ifscCode,
      partner: finalUser.refcode,
    };
    dispatch(verifyIFSC(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "Fetched Bank details Successfully") {
          setFormValues((prevState) => ({
            ...prevState,
            bank_name: response.bankdata.bank_name,
          }));
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const handleSaveClick = () => {
    const newErrors: FormErrors = {};
    if (!formValues.accountNo) {
      newErrors.accountNo = "Account number cannot be empty.";
    }
    if (!formValues.confirmAccountNo) {
      newErrors.confirmAccountNo = "Confirm account number cannot be empty.";
    }
    if (formValues.confirmAccountNo !== formValues.accountNo) {
      newErrors.confirmAccountNo = "Confirm account number doesn't match.";
    }

    if (!formValues.fullname) {
      newErrors.fullname = "Fullname cannot be empty.";
    }
    if (!formValues.ifscCode) {
      newErrors.ifscCode = "IfscCode  cannot be empty.";
    }
    // if there are errors, update state with them
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      handleSave(formValues);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            Add Bank
          </H5>
        </Box>
        <Box sx={container}>
          <TextField
            label="Enter Bank Account No."
            name="accountNo"
            value={formValues.accountNo ? formValues.accountNo : ""}
            error={!!formErrors.accountNo}
            helperText={formErrors.accountNo}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            // InputProps={{
            //   style: {
            //     height: "40px", // change this value to set the desired height
            //   },
            // }}
          />
          <TextField
            label="Confirm Account No."
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            name="confirmAccountNo"
            value={
              formValues.confirmAccountNo ? formValues.confirmAccountNo : ""
            }
            error={!!formErrors.confirmAccountNo}
            helperText={formErrors.confirmAccountNo}
          />
          <TextField
            label="Full Name"
            // value={value}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            name="fullname"
            value={formValues.fullname ? formValues.fullname : ""}
            error={!!formErrors.fullname}
            helperText={formErrors.fullname}
          />
          <TextField
            label="IFSC Code"
            // value={value}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            onBlur={onhandleIFSCBlur}
            sx={textInputStyles}
            name="ifscCode"
            value={formValues.ifscCode ? formValues.ifscCode : ""}
            error={!!formErrors.ifscCode}
            helperText={formErrors.ifscCode}
          />
          <Box sx={buttonContainer}>
            <Button
              variant="contained"
              onClick={handleClose}
              sx={[cancel, { textTransform: "none" }]}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveClick}
              sx={[add, { textTransform: "none" }]}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddBankModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md: "30%",
    xs: "90%",
  },
  bgcolor: "background.paper",

  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};

const header = {
  width: "100%",
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  // justifyContent: "center",
  //alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "100%",
  justifyContent: "space-between",
  flexDirection: {
    md: "row",
    xs: "column",
  },
  display: "flex",

  mt: {
    md: 2.5,
    xs: 1,
  },
};

const cancel = {
  background: "#FFF5D1",
  color: "#000",
  width: {
    md: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "98%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 1.5,
  },
};
